import { Component } from '@angular/core';

@Component({
    selector: 'app-card-status',
    standalone: true,
    imports: [],
    templateUrl: './card-status.component.html',
    styleUrl: './card-status.component.css'
})
export class CardStatusComponent {

}
